import i18n from "../../i18n";
import apiClient from "./apiClient";

interface LooseObject {
  [key: string]: any;
}

export type AuditEventsFilters = {
  userFio?: string;
  orgIinBin?: string;
  objectId?: string;
  eventType?: string | string[];
  description?: string | string[] | null;
  clientApp?: string | null;
  createdAtFrom?: string;
  createdAtTo?: string;
};

export const getAuditEventsList = async (
  currentPage: number = 1,
  itemsPerPage: number = 10,
  sortDirection: "ASC" | "DESC" = "DESC",
  filters?: AuditEventsFilters,
): Promise<any> => {
  try {
    const params = new URLSearchParams({
      page: currentPage.toString(),
      size: itemsPerPage.toString(),
      sortDirection,
    }).toString();

    const requestBody: LooseObject = {};

    if (filters?.userFio) {
      requestBody.userFio = filters.userFio;
    }
    if (filters?.orgIinBin) {
      requestBody.orgIinBin = filters.orgIinBin;
    }
    if (filters?.objectId) {
      requestBody.objectId = filters.objectId;
    }
    if (filters?.eventType) {
      if (Array.isArray(filters.eventType)) {
        if (filters.eventType.length > 0) {
          requestBody.eventType = filters.eventType;
        }
      } else {
        requestBody.eventType = filters.eventType;
      }
    }
    if (filters?.description) {
      if (Array.isArray(filters.description)) {
        if (filters.description.length > 0) {
          requestBody.action = filters.description;
        }
      } else {
        requestBody.action = filters.description;
      }
    }
    if (filters?.clientApp) {
      requestBody.clientApp = filters.clientApp;
    }
    if (filters?.createdAtFrom) {
      requestBody.from = `${filters.createdAtFrom}`;
    }
    if (filters?.createdAtTo) {
      requestBody.to = `${filters.createdAtTo}`;
    }

    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_AUDIT_SERVICE}/audit-events/search?${params}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching audit events list:", error);
    throw error;
  }
};

export const exportAuditEventsList = async (
  sortDirection: "ASC" | "DESC" = "DESC",
  filters?: AuditEventsFilters,
): Promise<any> => {
  try {
    const params = new URLSearchParams({
      sortDirection,
    }).toString();

    const requestBody: LooseObject = {};

    if (filters?.userFio) {
      requestBody.userFio = filters.userFio;
    }
    if (filters?.orgIinBin) {
      requestBody.orgIinBin = filters.orgIinBin;
    }
    if (filters?.objectId) {
      requestBody.objectId = filters.objectId;
    }
    if (filters?.eventType) {
      if (Array.isArray(filters.eventType)) {
        if (filters.eventType.length > 0) {
          requestBody.eventType = filters.eventType;
        }
      } else {
        requestBody.eventType = filters.eventType;
      }
    }
    if (filters?.description) {
      if (Array.isArray(filters.description)) {
        if (filters.description.length > 0) {
          requestBody.action = filters.description;
        }
      } else {
        requestBody.action = filters.description;
      }
    }
    if (filters?.clientApp) {
      requestBody.clientApp = filters.clientApp;
    }
    if (filters?.createdAtFrom) {
      requestBody.from = `${filters.createdAtFrom}`;
    }
    if (filters?.createdAtTo) {
      requestBody.to = `${filters.createdAtTo}`;
    }

    const response = await apiClient.post(
      `${process.env.REACT_APP_URL_AUDIT_SERVICE}/audit-events/export?${params}`,
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": i18n.language?.includes("ru") ? "ru-RU" : "kk-KZ",
        },
        withCredentials: true,
        responseType: "blob",
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error exporting audit events list:", error);
    throw error;
  }
};
